import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { Form } from 'semantic-ui-react'
import { GetReservationsReportForHotelOwner } from '../../../api/services/pms'
import { useTextResources } from '../../../language'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import HotelsDropDown from '../../shared/HotelsDropDown'
import RoomTypesDropDown from '../../shared/RoomTypesDropDown'
import moment from 'moment'
import { endpoint } from '../../../api/http'
import { Currencies } from '../../shared/currencies'
import { Icon } from 'semantic-ui-react'
import { Popup } from 'semantic-ui-react'
import { dateFormat } from '../../shared/constants'
import { createExcelHeader } from '../../GridPanel/utility'



const ReservationsByCheckInDateForHotelOwnerReport = () => {
    const text = useTextResources()
    const [dates, setDates] = useState([new Date(), new Date()])
    const [currencySymbol, setCurrencySymbol] = useState()
    const [hotelIds, setHotelIds] = useState([]);

    useEffect(() => {
        setCurrencySymbol(getCurrencyByCurrentHotel())
    }, [])

    const getCurrencyByCurrentHotel = useCallback(() => {
        const currencyCode = window.optima?.user?.CurrentHotel?.MainCurrencyId;
        return Currencies[currencyCode]?.symbol ?? '';
    })

    const reservationFormatter = ({ value, row }) => {
        if (row) {
            return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>
                {value}
            </a>
        } else {
            return value
        }
    }

    const commentsFormatter = ({ value }) => {
        if (value) return (
            <Popup
                content={<p style={{ fontSize: '12px' }}>{value}</p>}
                position='bottom center'
                mouseEnterDelay={100}
                mouseLeaveDelay={50}
                trigger={<Icon name='comment' />}
            />)
        return "";
    }



    const getFormatedDate = (index) => {
        return dates &&
            moment(dates[index]).toISOString()
    }

    const getDisplayFormatedDate = (index) => {
        return dates &&
            moment(dates[index]).format(dateFormat)
    }

    const currencyFormatter = ({ value }) => {
        return value && `${value.toFixed(2)} ${currencySymbol}`
    }

    const nightsFormatter = ({ value }) => {
        //used for table rows formatting
        if (Number.isInteger(value)) return value;

        //used for avg calculation
        return value && `${value.toFixed(1)}`
    }

    const getDateCellValue = (row, columnName) => {
        const date = row[columnName];
        return date && moment(date).format(dateFormat);
    }

    const basicSpec = {
        ReservationStatuses: [1, 2, 3],
        IncludeCanceled: true,
        IncludeAddons: true,
        IncludeAddonsWithChain: true,
        IncludeRoom: true,
        IncludeUsers: true,
        IncludeGuest: true,
    }

    const roomTypeSpec = useMemo(() => {
        return { HotelIds: hotelIds }
    }, [hotelIds])

    const excelHeaderTitle = `${text("ReservationsByCheckInDateForHotelOwner")} ${getDisplayFormatedDate(0)} - ${getDisplayFormatedDate(1)}`;

    const gridOptions = {
        search: {
            title: text("ReservationsByCheckInDateForHotelOwner"),
            fields: [
                <Form.Field label={text("Hotel")}
                    control={HotelsDropDown}
                    key="HotelIDs" clearable width="3"
                    placeholder={text("All")} multiple
                    onChange={setHotelIds} />,
                <Form.Field label={text("RoomType")}
                    control={RoomTypesDropDown}
                    key="RoomTypeIds" clearable width="3"
                    placeholder={text("All")} multiple spec={roomTypeSpec} />,
                <DatePicker label={text("SpecificDate")}
                    picktype='range' key="CheckInDate" width="2"
                    value={dates} onChange={setDates}
                    maxDate={moment().endOf('month').toDate()} />,
            ],
            api: GetReservationsReportForHotelOwner,
            spec: {
                FromCheckInDate: getFormatedDate(0),
                ToCheckInDate: getFormatedDate(1),
                ...basicSpec
            },
            groupSize: 6
        },
        grid: {
            columns: [
                { name: 'HotelName', title: text("HotelName") },
                { name: 'RoomName', title: text("RoomName") },
                { name: 'ReservationNumber', title: text('Reservation'), formatter: reservationFormatter },
                { name: 'CheckInDate', title: text("CheckInDate"), getCellValue: getDateCellValue },
                { name: 'CheckOutDate', title: text("CheckOutDate"), getCellValue: getDateCellValue },
                { name: 'GuestFullName', title: text("GuestName") },
                { name: 'GuestPhone', title: text("GuestPhone") },
                { name: 'GuestEmail', title: text("GuestEmail") },
                { name: 'GuestsSummary', title: text("TotalGuests") },
                { name: 'Nights', title: text("Nights"), formatter: nightsFormatter },
                { name: 'TotalIncomeByHotelMainCurrency', title: text("TotalIncome"), formatter: currencyFormatter },
                { name: 'AddOnsNames', title: text("ExtraAddons") },
                { name: 'Comments', title: text("Comments"), formatter: commentsFormatter },
                { name: 'CreatedByUser', title: text("CreatedByUser") },
            ],
            summary: true,
            totalSummaryItems: [
                { columnName: 'ReservationNumber', type: 'count' },
                { columnName: 'Nights', type: 'avg' },
                { columnName: 'Nights', type: 'sum' },
                { columnName: 'TotalIncomeByHotelMainCurrency', type: 'sum' },
            ],
            export: true,
            cacheId:'ReservationByCheckinDateForHotelOwner',
            customOptions:{
                sort:{
                    sorting: [{ columnName: 'CheckInDate' }]
                }
            },
            excel: {
                customizeHeader: createExcelHeader(excelHeaderTitle),
                totalSummaryItems: [
                    { columnName: 'ReservationNumber', type: 'count' },
                    { columnName: 'Nights', type: 'avg', displayFormat: '{0:00}' },
                    { columnName: 'Nights', type: 'sum' },
                    { columnName: 'TotalIncomeByHotelMainCurrency', type: 'sum', currencyFormatter },
                ],
            },
            pdf: true,
            scrollbarX: true
        }
    }
    return (<GridSearchTemplate options={gridOptions} />)
}
export default ReservationsByCheckInDateForHotelOwnerReport
